/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiPaymentV1Id$Json } from '../fn/payment/delete-api-payment-v-1-id-json';
import { DeleteApiPaymentV1Id$Json$Params } from '../fn/payment/delete-api-payment-v-1-id-json';
import { deleteApiPaymentV1Id$Plain } from '../fn/payment/delete-api-payment-v-1-id-plain';
import { DeleteApiPaymentV1Id$Plain$Params } from '../fn/payment/delete-api-payment-v-1-id-plain';
import { getApiPaymentV1Id$Json } from '../fn/payment/get-api-payment-v-1-id-json';
import { GetApiPaymentV1Id$Json$Params } from '../fn/payment/get-api-payment-v-1-id-json';
import { getApiPaymentV1Id$Plain } from '../fn/payment/get-api-payment-v-1-id-plain';
import { GetApiPaymentV1Id$Plain$Params } from '../fn/payment/get-api-payment-v-1-id-plain';
import { PaymentModel } from '../models/payment-model';
import { PaymentResponseModel } from '../models/payment-response-model';
import { postApiPaymentV1$Json } from '../fn/payment/post-api-payment-v-1-json';
import { PostApiPaymentV1$Json$Params } from '../fn/payment/post-api-payment-v-1-json';
import { postApiPaymentV1$Plain } from '../fn/payment/post-api-payment-v-1-plain';
import { PostApiPaymentV1$Plain$Params } from '../fn/payment/post-api-payment-v-1-plain';
import { postApiPaymentV1Create$Json } from '../fn/payment/post-api-payment-v-1-create-json';
import { PostApiPaymentV1Create$Json$Params } from '../fn/payment/post-api-payment-v-1-create-json';
import { postApiPaymentV1Create$Plain } from '../fn/payment/post-api-payment-v-1-create-plain';
import { PostApiPaymentV1Create$Plain$Params } from '../fn/payment/post-api-payment-v-1-create-plain';
import { putApiPaymentV1Id$Json } from '../fn/payment/put-api-payment-v-1-id-json';
import { PutApiPaymentV1Id$Json$Params } from '../fn/payment/put-api-payment-v-1-id-json';
import { putApiPaymentV1Id$Plain } from '../fn/payment/put-api-payment-v-1-id-plain';
import { PutApiPaymentV1Id$Plain$Params } from '../fn/payment/put-api-payment-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class PaymentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiPaymentV1()` */
  static readonly PostApiPaymentV1Path = '/private/v1/payments';

  /**
   * Retrive the list all the existing Payments from the database asynchronously.
   *
   * Retrive the list all the existing Payments from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiPaymentV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1$Plain$Response(params?: PostApiPaymentV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentResponseModel>> {
    return postApiPaymentV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Payments from the database asynchronously.
   *
   * Retrive the list all the existing Payments from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiPaymentV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1$Plain(params?: PostApiPaymentV1$Plain$Params, context?: HttpContext): Observable<PaymentResponseModel> {
    return this.postApiPaymentV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentResponseModel>): PaymentResponseModel => r.body)
    );
  }

  /**
   * Retrive the list all the existing Payments from the database asynchronously.
   *
   * Retrive the list all the existing Payments from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiPaymentV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1$Json$Response(params?: PostApiPaymentV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentResponseModel>> {
    return postApiPaymentV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive the list all the existing Payments from the database asynchronously.
   *
   * Retrive the list all the existing Payments from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiPaymentV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1$Json(params?: PostApiPaymentV1$Json$Params, context?: HttpContext): Observable<PaymentResponseModel> {
    return this.postApiPaymentV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentResponseModel>): PaymentResponseModel => r.body)
    );
  }

  /** Path part for operation `getApiPaymentV1Id()` */
  static readonly GetApiPaymentV1IdPath = '/private/v1/payments/{id}';

  /**
   * Retrive a Payment by Id from the database asynchronously.
   *
   * Retrive a Payment by Id from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiPaymentV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPaymentV1Id$Plain$Response(params: GetApiPaymentV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentModel>> {
    return getApiPaymentV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive a Payment by Id from the database asynchronously.
   *
   * Retrive a Payment by Id from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiPaymentV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPaymentV1Id$Plain(params: GetApiPaymentV1Id$Plain$Params, context?: HttpContext): Observable<PaymentModel> {
    return this.getApiPaymentV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentModel>): PaymentModel => r.body)
    );
  }

  /**
   * Retrive a Payment by Id from the database asynchronously.
   *
   * Retrive a Payment by Id from the database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiPaymentV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPaymentV1Id$Json$Response(params: GetApiPaymentV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentModel>> {
    return getApiPaymentV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrive a Payment by Id from the database asynchronously.
   *
   * Retrive a Payment by Id from the database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiPaymentV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPaymentV1Id$Json(params: GetApiPaymentV1Id$Json$Params, context?: HttpContext): Observable<PaymentModel> {
    return this.getApiPaymentV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentModel>): PaymentModel => r.body)
    );
  }

  /** Path part for operation `putApiPaymentV1Id()` */
  static readonly PutApiPaymentV1IdPath = '/private/v1/payments/{id}';

  /**
   * Update a Payment into database asynchronously by Id.
   *
   * Update a Payment into database asynchronously by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiPaymentV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiPaymentV1Id$Plain$Response(params: PutApiPaymentV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentModel>> {
    return putApiPaymentV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a Payment into database asynchronously by Id.
   *
   * Update a Payment into database asynchronously by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiPaymentV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiPaymentV1Id$Plain(params: PutApiPaymentV1Id$Plain$Params, context?: HttpContext): Observable<PaymentModel> {
    return this.putApiPaymentV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentModel>): PaymentModel => r.body)
    );
  }

  /**
   * Update a Payment into database asynchronously by Id.
   *
   * Update a Payment into database asynchronously by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiPaymentV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiPaymentV1Id$Json$Response(params: PutApiPaymentV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentModel>> {
    return putApiPaymentV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a Payment into database asynchronously by Id.
   *
   * Update a Payment into database asynchronously by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiPaymentV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiPaymentV1Id$Json(params: PutApiPaymentV1Id$Json$Params, context?: HttpContext): Observable<PaymentModel> {
    return this.putApiPaymentV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentModel>): PaymentModel => r.body)
    );
  }

  /** Path part for operation `deleteApiPaymentV1Id()` */
  static readonly DeleteApiPaymentV1IdPath = '/private/v1/payments/{id}';

  /**
   * Delete a Payment from database asynchronously by Id.
   *
   * Delete a Payment from database asynchronously by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiPaymentV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiPaymentV1Id$Plain$Response(params: DeleteApiPaymentV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return deleteApiPaymentV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a Payment from database asynchronously by Id.
   *
   * Delete a Payment from database asynchronously by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiPaymentV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiPaymentV1Id$Plain(params: DeleteApiPaymentV1Id$Plain$Params, context?: HttpContext): Observable<boolean> {
    return this.deleteApiPaymentV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * Delete a Payment from database asynchronously by Id.
   *
   * Delete a Payment from database asynchronously by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiPaymentV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiPaymentV1Id$Json$Response(params: DeleteApiPaymentV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return deleteApiPaymentV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a Payment from database asynchronously by Id.
   *
   * Delete a Payment from database asynchronously by Id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiPaymentV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiPaymentV1Id$Json(params: DeleteApiPaymentV1Id$Json$Params, context?: HttpContext): Observable<boolean> {
    return this.deleteApiPaymentV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `postApiPaymentV1Create()` */
  static readonly PostApiPaymentV1CreatePath = '/private/v1/payments/Create';

  /**
   * Create a new Payment into database asynchronously.
   *
   * Create a new Payment into database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiPaymentV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1Create$Plain$Response(params?: PostApiPaymentV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentModel>> {
    return postApiPaymentV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new Payment into database asynchronously.
   *
   * Create a new Payment into database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiPaymentV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1Create$Plain(params?: PostApiPaymentV1Create$Plain$Params, context?: HttpContext): Observable<PaymentModel> {
    return this.postApiPaymentV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentModel>): PaymentModel => r.body)
    );
  }

  /**
   * Create a new Payment into database asynchronously.
   *
   * Create a new Payment into database asynchronously
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiPaymentV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1Create$Json$Response(params?: PostApiPaymentV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentModel>> {
    return postApiPaymentV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new Payment into database asynchronously.
   *
   * Create a new Payment into database asynchronously
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiPaymentV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiPaymentV1Create$Json(params?: PostApiPaymentV1Create$Json$Params, context?: HttpContext): Observable<PaymentModel> {
    return this.postApiPaymentV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentModel>): PaymentModel => r.body)
    );
  }

}
